module.exports = __webpack_public_path__ + "img/administrador.8a7cd4a0.png";